// cookie.js

export const Cookie = {
    setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        document.cookie = `${name}=${value}${expires}; path=/`;
    },

    getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let c of ca) {
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
        }
        return null;
    },

    deleteCookie(name) {
        this.setCookie(name, "", -1);
    }
};

export const cookiebar = {
    cookieBarCookieName: 'cookies_accepted',
    cookieBarClosedCookieName: 'cookiebar_closed',
    cookieBarId: 'cookiebar',
    cookiebarHtml: '<div class="cookiebar"><div class="cookiebar__inner">Deze website maakt gebruik van cookies. <a href="[URL]">Klik hier</a> voor meer informatie. <span class="buttons"><button class="button">Akkoord</button><button class="button-cookie-cancel">Alleen anonieme cookies</button></span></div></div>',
    cookieFallbackPage: '/privacy-cookies',

    init($) {
        if (Cookie.getCookie(this.cookieBarClosedCookieName) == null) {
            let cookiebarBar = this.cookiebarHtml;
            if (typeof siteConfig !== 'undefined' && siteConfig.privacypage) {
                cookiebarBar = cookiebarBar.replace('[URL]', siteConfig.privacypage);
            } else {
                cookiebarBar = cookiebarBar.replace('[URL]', this.cookieFallbackPage);
            }

            const $cookiebarElm = $(cookiebarBar).attr('id', this.cookieBarId);
            $('body').prepend($cookiebarElm);

            $('button.button', $cookiebarElm).on('click', () => {
                this.closeCookiebarAccept($);
            });

            $('button.button-cookie-cancel', $cookiebarElm).on('click', () => {
                this.closeCookiebar($);
            });
        }
    },

    closeCookiebar($) {
        $('#' + this.cookieBarId).remove();
        Cookie.setCookie(this.cookieBarClosedCookieName, true, 365);
    },

    closeCookiebarAccept($) {
        $('#' + this.cookieBarId).remove();
        Cookie.setCookie(this.cookieBarClosedCookieName, true, 365);
        Cookie.setCookie(this.cookieBarCookieName, true, 365);
    }
};
